import { type ButtonProperties, FormActions } from 'ui';

type P = {
  acceptTitle?: string;
  isAccepting?: boolean;
  isRejecting?: boolean;
  left?: ButtonProperties;
  onClose: () => void;
  onReject?: () => Promise<void> | void;
  rejectTitle?: string;
  submit?: ButtonProperties;
};

const ConsentsFormActions = ({
  acceptTitle,
  isAccepting,
  isRejecting,
  left,
  onClose,
  onReject,
  rejectTitle,
  submit,
}: P) => (
  <FormActions
    left={
      onReject
        ? {
            children: rejectTitle ?? 'Log out',
            loading: isRejecting,
            onClick: onClose,
            ...left,
          }
        : undefined
    }
    submit={{
      children: acceptTitle ?? 'Continue',
      loading: isAccepting,
      ...submit,
    }}
  />
);

export default ConsentsFormActions;
